import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

export default function SharcIdPage() {
    const { sharcId } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!sharcId) return;
        axios.get(`${config.API_URL}/resolve/${sharcId}`)
            .then(res => {
                const { type, slug } = res.data;
                if (type === 'artist') navigate(`/artists/${slug}`, { replace: true });
                else if (type === 'venue') navigate(`/venues/${slug}`, { replace: true });
                else if (type === 'event') navigate(`/events/${slug}`, { replace: true });
                else if (type === 'member') navigate(`/members/${slug}`, { replace: true });
                else setError('Unknown record type.');
            })
            .catch(() => setError(`No SHARC record found for "${sharcId}".`));
    }, [sharcId, navigate]);

    const styles = {
        container: { maxWidth: '600px', margin: '80px auto', padding: '0 24px', textAlign: 'center', color: '#e0e0e0' },
        sharcId: { fontSize: '32px', fontWeight: 700, color: '#bb86fc', marginBottom: '12px' },
        message: { fontSize: '16px', color: '#aaa' },
        error: { fontSize: '16px', color: '#cf6679' },
    };

    return (
        <div style={styles.container}>
            <div style={styles.sharcId}>/{sharcId}</div>
            {error
                ? <div style={styles.error}>{error}</div>
                : <div style={styles.message}>Resolving SHARC ID...</div>
            }
        </div>
    );
}
